module.exports = __webpack_public_path__ + "img/trash-bin-outline.7157ceb8.svg";